import React from "react";
import { Call, MapOutlined, Watch } from "@mui/icons-material";
import Speciality from "./Speciality";
import About from "../../About";
import { Link } from "react-router-dom";

function AboutUs() {
  return (
    <section>
      <div className="about-wrapper mt-3 mb-4">
        <div className="">
          <div className="pt-2 mt-3 bg-light">
            <About />
          </div>
          <Speciality />
        </div>

      </div>
      <div className="location-map">
        <div className="map-sec space">
          <div className="map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31638.92194641107!2d-1.9543114105582027!3d7.589642915187308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfda8f6cf4c278ad%3A0x35b150d58886b9fa!2sTechiman!5e0!3m2!1sen!2sgh!4v1696952474051!5m2!1sen!2sgh"
              width="600" height="450"
              title="DEEPBLUE Loctation"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <div className="container">
            <div className="map-contact">
              <h2 className=" section-subtitle">Get in Touch</h2>
              <p className="mt-1 mb-2 p-text">
                Have a inquiry or some feedback for us? Fill out the form at <Link to="/contact-sales" className="link">
                  contact our sales team.</Link> Or you can visit us anytime for your inquiries.
              </p>
              <div className="contact-info ">
                <div className="contact-info_icon">
                  <span className="">
                    <MapOutlined />
                  </span>
                </div>
                <div className="media-body ">
                  <h4 className="contact-info_title">Our Address</h4>
                  <span className="contact-info_text">
                    Techiman, Bono East Region - Ghana
                  </span>
                </div>
              </div>
              <div className="contact-info">
                <div className="contact-info_icon">
                  <span className="">
                    <Call />
                  </span>
                </div>
                <div className="media-body">
                  <h4 className="contact-info_title">Phone Number</h4>
                  <span className="contact-info_text">
                    <span className="row">
                      <p> Mobile:</p>
                      <a href="tel:+2333200286602" className="ml-2">
                        (+233) - 20 -028 - 6602
                      </a>
                      <br />
                    </span>
                    <span>
                      <a href="tel:+233542839173" className="ml-2">
                        (+233) - 54 - 283 - 9173
                      </a>
                    </span>
                  </span>
                </div>
              </div>
              <div className="contact-info">
                <div className="contact-info_icon">
                  <span className="icon-watch">
                    <Watch />
                  </span>
                </div>
                <div className="media-body">
                  <h4 className="contact-info_title">Hours of Operation</h4>
                  <span className="contact-info_text">
                    <span>
                      Monday - Sunday <br /> 24 / 7
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}

export default AboutUs;
